import {
  GmailConnectRequest,
  PBRAuthResponse,
  PBRGmailAuthRequest,
} from '@playback-rewards/shared-libraries'
import { axiosBackendInstance } from '../axiosInstance'

export const generateBaseUrlForSecondaryEmail = async () => {
  return axiosBackendInstance.get('/auth/v2/generate-link/secondary')
}

export const authorize = async (authReq: PBRGmailAuthRequest): Promise<PBRAuthResponse> => {
  return await axiosBackendInstance.post(`/api/v2/auth/authorize/gmail`, authReq)
}

export const connectGmail = async (
  connectGmailReq: GmailConnectRequest
): Promise<PBRAuthResponse> => {
  return await axiosBackendInstance.post(`/api/v2/auth/connect-gmail`, connectGmailReq)
}

export const closeGmailConnectModal = async (userId: string) => {
  return await axiosBackendInstance.put(`/api/v2/auth/modal/${userId}`)
}

export const generateAuthLinkPost = async (
  redirectUri: string,
  scopes: string[],
  signupAttribution: unknown,
  userId = null
) => {
  const url = `/auth/generate-link`

  return axiosBackendInstance.post(url, {
    redirectUri,
    scopes,
    state: signupAttribution,
    userId,
  })
}

export const handleLogoutBackend = async () => {
  const url = `/auth/logout`

  return axiosBackendInstance.post(url).catch((err) => {
    throw err
  })
}
export const updateRefreshTokenState = async (userId: string) => {
  return axiosBackendInstance.put(`/auth/refresh-token/${userId}`)
}

export const updateUserCountry = async (body: unknown) => {
  return axiosBackendInstance.put('/auth/select-country', body)
}

export const getAuthLinkWithScopes = async (email: string, signupAttr: string) => {
  return axiosBackendInstance.get(`/auth/v2/link/gmail?email=${email}&signupAttr=${signupAttr}`)
}

export const updateUserLastLoginData = async (data: unknown) => {
  return axiosBackendInstance.patch(`/auth/login-data`, data)
}
